import type { ShowFormArtifact } from '@kanbu/schema/contracts';
import { Trans } from '@lingui/react/macro';
import { Check, X } from 'lucide-react';

import { cn } from '../../lib/cn';

export interface FormSubmittedViewProps {
  artifact: ShowFormArtifact;
  data: Record<string, unknown>;
  className?: string;
}

function formatFieldValue(value: unknown): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  return String(value);
}

export function FormSubmittedView({
  artifact,
  data,
  className,
}: FormSubmittedViewProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-4 rounded-2xl bg-chat-background-secondary p-5 shadow-md',
        className,
      )}
    >
      <div className='flex items-start gap-3'>
        <div className='flex size-9 shrink-0 items-center justify-center rounded-full bg-chat-primary/15 text-chat-primary'>
          <Check className='size-4' strokeWidth={2.5} />
        </div>
        <div className='min-w-0 space-y-0.5'>
          <p className='font-semibold text-chat-foreground'>{artifact.title}</p>
          <p className='text-sm text-muted-fg'>
            <Trans>Submitted</Trans>
          </p>
        </div>
      </div>

      <dl className='grid gap-3'>
        {artifact.fields.map(field => (
          <div key={field.name} className='space-y-0.5'>
            <dt className='text-xs font-medium text-muted-fg'>{field.label}</dt>
            <dd className='text-sm text-chat-foreground'>
              {formatFieldValue(data[field.name])}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

export function FormCanceledView({
  artifact,
  className,
}: {
  artifact: ShowFormArtifact;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-start gap-3 rounded-2xl bg-chat-background-secondary p-5 shadow-md',
        className,
      )}
    >
      <div className='flex size-9 shrink-0 items-center justify-center rounded-full bg-chat-muted/30 text-muted-fg'>
        <X className='size-4' strokeWidth={2.5} />
      </div>
      <div className='min-w-0 space-y-0.5'>
        <p className='font-semibold text-chat-foreground'>{artifact.title}</p>
        <p className='text-sm text-muted-fg'>
          <Trans>Canceled</Trans>
        </p>
      </div>
    </div>
  );
}
